<template>
  <div
    class="radio"
    :class="{ column, disabled }"
  >
    <div class="item" v-for="( o, k ) in values_" :key="o.value">
      <input
        type="radio"
        :id="id + '_' + k"
        :name="id"
        :disabled="disabled"
        :value="o.value"
        :title="o.tip"
        :checked="o.value === value"
        @input="set"
      />
      <label
        class="radio__label"
        :for="id + '_' + k"
        :title="o.tip"
        v-html="o.label"
      />
    </div>
  </div>
</template>

<script>
import utils from "@/utils"

export default {
	name:  "Radio",

	props: {
		disabled: {
			type:    Boolean,
			default: false,
		},
		value:  {
			type:    String,
			default: false,
		},
    values:  {
			type:    Array,
			default: function() { return [ this.$t( "Yes" ), this.$t( "No" ) ]; },
      validate( vs ) {
			  for ( const v of vs ) {
			    if ( !v || ( typeof( v ) == "object" && !v.label ) ) return false;
        }

			  return true
      }
		},
    column: {
		  type: Boolean,
      default: false
    }
	},
	data() {
		return {
    	id: utils.uniqueHashGen( "dom_" )
		};
	},
	methods: {
		set( event ) {
			this.$emit( "input", event.target.value )
		},
	},
  computed: {
	  values_() {
	    return this.values.map(
        i => {
          if ( typeof( i ) == "object" ) {
            if ( "tip" in i && !i.tip ) delete i.tip;
            if ( !( "value" in i ) ) i.value = i.label;
          }
          else i = {
            label: i,
            value: i
          };

          return i;
        }
      );
    }
  }
};
</script>

<style scoped>
  .radio,
  .radio > .item {
	  display: inline-block;
    margin-right: 1em;
  }

	.radio > .item label {
    display: inline-block;
    position: relative;
		font-size: 1em;
		line-height: 1em;
		height: 1.1em;
		padding-left: 1.5em;
		cursor: pointer;
  }

  .radio > .item label:before {
    position: absolute;
    content: "";
  }

  .radio > .item label:before,
  .radio > .item label:after {
    content: "";
    position: absolute;
    border-radius: 100%;
    left: 0;
    top: 0;
    width: 1.1em;
    height: 1.1em;
    margin: auto;
    box-sizing: border-box;
  }

  .radio > .item label:before {
    z-index: 1;
    background-color: #FFFFFF;
    border: 2px solid #EBEBEB;
    transition: opacity .35s ease;
  }

  .radio > .item label:after {
    z-index: 2;
    transition: transform .35s ease;
    background-image: url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5 10L0 5.19231L1.4 3.84615L5 7.30769L12.6 0L14 1.34615L5 10Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 0.8em;
    transform: scale(0);
  }

	.radio > .item input {
		position: absolute;
		left: -9999px;
		top: 0;
		display: none;
  }

	.radio > .item input:checked + label:before {
    background-color: #E13833;
    border-color: #E13833;
  }
	.radio > .item input:checked + label:after {
		transform: scale(1);
  }

  .radio > .item label:hover:before,
  .radio > .item label:focus:after {
    background-color: #FFFFFF;
    border-color: #E13833;
  }

  .radio.column > .item {
    display: block;
    margin: 0.5em 0;
  }
  .radio > .item label:hover {
    color: #E13833;
  }

  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
</style>